import { FC, useContext, useEffect, Fragment } from 'react'
import clsx from 'clsx'
import dynamic from 'next/dynamic'

const Button = dynamic(() => import('../../parts/button/button'))
const SelectMobile = dynamic(
  () => import('../filter-parts/select/select-filter-mobile/select-filter-mobile')
)
const CheckBoxes = dynamic(() => import('../filter-parts/checkboxes/checkboxes'))
const Calendar = dynamic(() => import('components/filters/filter-parts/calendar/calendar'))
import ScrollArea from 'containers/scroll-area/scroll-area'
import Sidebar from '../../parts/sidebar/sidebar'
import FilterActive from '../filter-parts/filter-active/filter-active'
import SearchFilterContext from 'context/searchFilterContext'
import useOpenMobileFilters from '../useOpenMobileFilters'

import { enableDocumentScroll, disableDocumentScroll } from 'utils/handlerDocumentScroll'
import { formatDate } from 'utils/formatDate'
import { IOptions, IAnyObj } from 'constants/types/common.types'
import { IInitParams, IConfig } from 'constants/types/search.types'
import { A_filterUsage, originFilter } from 'utils/analytics/other/filter_usage/filter_usage'
import {
  FilterTypeName,
  Key,
  FilterIconName,
  filterIconPath,
} from 'constants/search-data/search-data'

import styles from './filter-mobile.module.scss'

interface IMobileFilter {
  parameters: IInitParams
  handleParameterSet: (key: string, value: string | string[]) => void
  handleReset: () => void
  config: IConfig
  allCount: number
  origin?: originFilter
}

const MobileFilters: FC<IMobileFilter> = ({
  parameters,
  handleParameterSet,
  handleReset,
  config,
  allCount,
  origin,
}) => {
  //TODO UseOpenMobileFilters и setFilter можно ли оставить что-то одно?
  const { filterState, setFilter } = useContext(SearchFilterContext)

  const { handleCloseFilter, handleChangeFilter } = useOpenMobileFilters()
  const handleValue = (key: string) => (value: any) => {
    /* Чтобы можно было вибирать дату в календаре от большего к меньшему */
    if (key === Key.DATES && value[0] < parameters[Key.DATES][0]) {
      return handleParameterSet(key, [value[0], parameters.dates[0]])
    }
    origin && A_filterUsage(origin, key)
    handleParameterSet(key, value)
  }

  const stringResults = `Результаты (${allCount})`

  useEffect(() => {
    // if (filterState) {
    //   return disableDocumentScroll()
    // } else enableDocumentScroll()
  }, [filterState])

  /* TODO подумать как сделать получше*/
  const SelectedDate = () => {
    const startDate = parameters.dates[0]
    const endDate = parameters.dates[1]
    return (
      startDate instanceof Date &&
      endDate instanceof Date && (
        <span>&nbsp;{`(${formatDate(startDate)} - ${formatDate(endDate)})`}</span>
      )
    )
  }

  return (
    <>
      <Sidebar
        isActive={Boolean(filterState)}
        title="Фильтры"
        iconData={filterIconPath[FilterIconName.CLOSE]}
        btnBackHandler={handleChangeFilter}
      >
        <div className={styles.scrollWrap}>
          <ScrollArea>
            <div className={styles.mobileFiltersWrapper}>
              {config.main.map((item: IAnyObj, index: number) => {
                const key = item.title || item.key

                const isCheckbox = item.inputType === FilterTypeName.CHECKBOX
                const isCalendar = item.inputType === FilterTypeName.CALENDAR
                const isSelect = item.inputType === FilterTypeName.SELECT

                return (
                  <Fragment key={key}>
                    {isCheckbox && (
                      <div className={clsx(styles.mobileFilterItem, styles.mobileFilterCheckbox)}>
                        <CheckBoxes
                          datasets={item.checkboxes}
                          values={parameters[item.key] as string[]}
                          handler={handleValue(item.key)}
                        />
                      </div>
                    )}
                    {isSelect && (
                      <div className={styles.mobileFilterItem} onClick={() => setFilter(index + 2)}>
                        {item.title}
                        <span>
                          {parameters[item.key].length ? `(${parameters[item.key].length})` : ''}
                        </span>
                      </div>
                    )}
                    {isCalendar && (
                      <div className={styles.mobileFilterItem} onClick={() => setFilter(index + 2)}>
                        {item.title}
                        {SelectedDate()}
                      </div>
                    )}
                  </Fragment>
                )
              })}
              <FilterActive
                config={config}
                parameters={parameters}
                handleValue={handleValue}
                handleReset={handleReset}
              />
            </div>
          </ScrollArea>
        </div>
        {filterState === 1 && (
          <div className={styles.mobileAgreeButton}>
            <Button onClick={handleCloseFilter}>{stringResults}</Button>
          </div>
        )}
      </Sidebar>

      {Boolean(filterState) &&
        config.main.map((item, index) => {
          const isActive = filterState === index + 2
          const key = item.title || item.key
          const props = {
            isActive,
            title: item.title,
            iconData: filterIconPath[FilterIconName.BACK],
            btnBackHandler: handleChangeFilter,
          }

          if (item.inputType === FilterTypeName.CHECKBOX) {
            return (
              <Sidebar key={key} {...props}>
                <CheckBoxes
                  datasets={item.checkboxes}
                  values={parameters[item.key] as string[]}
                  handler={handleValue(item.key)}
                  isSingleChoise={item.key === Key.NMO}
                />
                <div className={styles.mobileAgreeButton}>
                  <Button onClick={handleCloseFilter}>{stringResults}</Button>
                </div>
              </Sidebar>
            )
          } else if (item.inputType === FilterTypeName.SELECT) {
            return (
              <Sidebar key={key} {...props}>
                <SelectMobile
                  inputId={item.key}
                  options={item.themes}
                  values={parameters[item.key] as IOptions[]}
                  setValues={handleValue(item.key)}
                  placeholder={item.placeholder}
                  customStyles={item.customStyles}
                />
                <div className={styles.mobileAgreeButton}>
                  <Button onClick={handleCloseFilter}>{stringResults}</Button>
                </div>
              </Sidebar>
            )
          } else if (item.inputType === FilterTypeName.CALENDAR) {
            return (
              <Sidebar key={key} {...props} setDates={handleValue(item.key)}>
                <div className={styles.scrollWrap}>
                  <ScrollArea>
                    <div className={styles.calendar}>
                      <div className={styles.calendarCenter}>
                        <Calendar
                          dates={parameters[item.key] as Date[]}
                          maxDate={item.maxDate}
                          minDate={item.minDate}
                          withoutBtn={true}
                          setDates={handleValue(item.key)}
                        />
                      </div>
                    </div>
                  </ScrollArea>
                </div>
                <div className={styles.mobileAgreeButton}>
                  <Button onClick={handleCloseFilter}>{stringResults}</Button>
                </div>
              </Sidebar>
            )
          }
        })}
    </>
  )
}

export default MobileFilters
